import React, { useEffect, useState, useCallback } from 'react';
import LineGraph from '../../components/LineGraph';
import PointList from '../../components/PointList';
import { equipmentById, getPointsForEquipment, addProduct, updateEquipment, addEquipmentNote, getEquipmentNotes, getEquipmentContacts, associateEquipmentContact, getCommunicationInterfaces, addInterface, getRelatedEquipment, getSiteEquipment, addRelatedEquipment, removeRelatedEquipment, addEquipmentPoint, updateEquipmentPoint, deleteEquipmentPoint } from '../../services/MetadataService';
import { getUtilityTariffs } from "../../services/RateService";
import useGlobal from '../../store';
import { useHistory } from 'react-router-dom';
import { Button, Autocomplete, IconButton, TextField, RadioGroup, Radio, Checkbox, FormControlLabel, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab'
import { ModeEdit, Settings } from '@mui/icons-material';
import { KeyboardDatePicker } from "@material-ui/pickers";
import {Auth} from "aws-amplify";

import { getBrickEquipmentTypes, getEquipmentSystems, getAllProtocols, getAllPhysicalConnectionTypes, getAllUnits, getBrickPointTypes } from "../../services/DimensionsServices";

import { getProducts, addProductToAirtable } from "../../services/ProductGuideService";
import { getEntityDocuments } from '../../services/FileService';
import FileList from '../../components/FileList';
import PhotoCarousel from '../../components/PhotoCarousel';
import Notes from '../../components/Notes';
import ContactsList from '../../components/ContactsList';
import CommunicationInterfaceModal from "../../components/CommunicationInterfaceModal"
import RelatedEquipmentList from '../../components/RelatedEquipmentList';
import MergeEquipmentForm from '../../components/MergeEquipmentForm';
import LoadedControls from '../../loaded/LoadedControls';
import EntityAutocomplete from '../../components/EntityAutocomplete';


function parseISOString(s) {
	if (!s) return null;

	var b = s.split(/\D+/);
	return new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5], b[6]));
  }

//TODO Edit portion of this needs to move to its own component
const ShowEquipment = (props) => {
	const [loading, setLoading] = useState(false);
	const [equipment, setEquipment] = useState();
	const [points, setPoints] = useState();
	const [location, setLocation] = useState('Equipment');
	const [files, setFiles] = useState();
	const [photos, setPhotos] = useState();
	const [notes, setNotes] = useState();
	const [relatedEquipment, setRelatedEquipment] = useState();

	const [selectedHeader, setSelectedHeader] = useState('graph');
	let [currentUser, setCurrentUser] = useState()

	let [brickTypes, setBrickTypes] = useState([])
	let [systemOptions, setSystemOptions] = useState([])
	let [products, setProducts] = useState([])
	let [interfaces, setInterfaces] = useState([])
	let [allEquipment, setAllEquipment] = useState([])
    let [tariffs, setTariffs] = useState([])

	let [company, setCompany] = useState()
	let [model, setModel] = useState()

	let [openInterfaceModal, setOpenInterfaceModal] = useState(false)

	let [showProductMode, setShowProductMode] = useState('existing')
	let [interfaceMode, setInterfaceMode] = useState('existing')

	const [editMode, setEditMode] = useState();
	const [error, setError] = useState();
	const [isSubmitting, setIsSubmitting] = useState(false)

	let [currentState, currentActions] = useGlobal();

	let history = useHistory();

	useEffect(() => {
		const equipmentId = props && props.equipmentId;
		equipmentById(equipmentId).then((response) => {
			setEquipment(response);

			if (response.product == null) {
				setShowProductMode('unknown')
			}

			getCommunicationInterfaces(response.site.site_id).then(response => {
				setInterfaces(response);
			})

			getSiteEquipment(response.site.site_id).then(response => {
				setAllEquipment(response);
			})

			getUtilityTariffs(response.site.latitude, response.site.longitude).then(tariffs => {
				setTariffs(tariffs)
			})

			console.log(currentState)
		});

		getPointsForEquipment(equipmentId).then((response) => {
			setPoints(response);
		});

		getRelatedEquipment(equipmentId).then(response => {
			setRelatedEquipment(response);
		})

		getBrickEquipmentTypes().then(response => {
			setBrickTypes(response)
		});

		getEquipmentSystems().then(response => {
			setSystemOptions(response)
		})

		if (!currentUser) {
            Auth.currentUserInfo().then(response => {
                setCurrentUser(response.attributes.name)
            })
        }

		getFiles(equipmentId);

		if (products.length == 0) {
            getProducts().then(response => {
                let products = [];
                response.forEach (r => {
                    products.push({
                        product_id: r.product_id,
                        label: r.company === "Unknown" ? "Unknown" : r.company + " " + r.model,
						company: r.company,
						model: r.model,
                    })
                })
                products.sort((a, b) => (a.label > b.label) ? 1 : -1)
                setProducts(products)
            })
        }
	},[])

    const fetchContacts = useCallback(() => {
		if (props.equipmentId) {
			return getEquipmentContacts(props.equipmentId);
		}
    }, [props.equipmentId])

	const getFiles = (id) => {
    let equipmentId = id || equipment.equipment_id
		let currentFiles = [];
		let currentPhotos = [];
		getEntityDocuments("equipment", equipmentId).then(files => {
			files.forEach(file => {
				if (file.type === 'Photo') {
					currentPhotos.push(file);
				}
				currentFiles.push(file)
			})

			setPhotos(currentPhotos)
			setFiles(currentFiles)
		})
	}

  useEffect(() => {
    if (equipment) {
		currentActions.setEquipment(equipment);
		currentActions.setSite(equipment.site);
    }
  }, [equipment]);

  useEffect(() => {
    if (currentState.currentModule !== location) {
		currentActions.setCurrentModule(location);
    }
  }, [location]);

  	const setName = (value) => {
		let currentEquipment = Object.assign({}, equipment);
		currentEquipment.name = value;
		setEquipment(currentEquipment)
	}

  	const setSelector = (value) => {
		let currentEquipment = Object.assign({}, equipment);
		currentEquipment.selector = value;
		setEquipment(currentEquipment)
	}

  	const setControlledBy = (value) => {
		let currentEquipment = Object.assign({}, equipment);
		currentEquipment.controlled_by = value;
		setEquipment(currentEquipment)
	}

	const toggleActive = () => {
		let currentEquipment = Object.assign({}, equipment);
		currentEquipment.is_active = !currentEquipment.is_active
		setEquipment(currentEquipment)
	}

	const setInstalledDate = (value) => {
		let currentEquipment = Object.assign({}, equipment);
		currentEquipment.installed_date = new Date(value);
		setEquipment(currentEquipment)
	}

	const cancelEdit = () => {
		setEditMode(false)
	}

	const submitChanges = () => {
		console.log('Saving Equipment', equipment)
		setIsSubmitting(true)
		let e = Object.assign({}, equipment)
		if (showProductMode === 'new' && company && model) {
			let product = {
				company: company,
				model: model,
				type: equipment.system,
				subtype: equipment.type
			}

			//This must be populated or will be lost.
			e.interface_id = e.communication_interface ? e.communication_interface.interface_id : null;

			addProductToAirtable(product).then(productId => {
				product.product_id = productId
				e.product = null
				addProduct(product).then(() => {
					e.product_id = productId
					updateEquipment(e).then(response => {
						setError(null)
						setEquipment(response)
						setEditMode(false)
						setIsSubmitting(false)
					}).catch(err => {
						console.log(err)
						setError("Failed to update equipment")
						setIsSubmitting(false)
					})
				}).catch(err => {
					console.log(err)
					setError("Failed to add new product")
					setIsSubmitting(false)
				})
			})
		} else {
			if (showProductMode === "unknown") {
				e.product_id = null;
			} else e.product_id = e.product.product_id

			//This must be populated or will be lost.
			e.interface_id = e.communication_interface ? e.communication_interface.interface_id : null;

			updateEquipment(e).then(response => {
				setError(null)
				setEquipment(response)
				setEditMode(false)
				setIsSubmitting(false)
			}).catch(err => {
				console.log(err)
				setError("Failed to update equipment")
				setIsSubmitting(false)
			})
		}
	}

	const addNote = async (note) => {
		note.author = currentUser;
		addEquipmentNote(equipment.equipment_id, note).then(() => {
			getEquipmentNotes(equipment.equipment_id).then(response => {
				setNotes(response)
			})
		}).catch(err => {
			console.log(err)
		})

	}

	const handleNewInterface = () => {
		setInterfaceMode('new'); 
		setOpenInterfaceModal(true);
		
		let current_equipment = Object.assign({}, equipment)
		current_equipment.communication_interface = null
		setEquipment(current_equipment)
	}

	const addCommsInterface = async (i) => {
		addInterface(equipment.site.site_id, i).then(() => {
			let currentEquipment = Object.assign({}, equipment)
			equipment.communication_interface = i
			setEquipment(currentEquipment)
			getCommunicationInterfaces(equipment.site.site_id).then(response => {
				setInterfaces(response)
			})
		})
    }

	const connectEquipment = async(equipmentList) => {
		equipmentList.forEach(e => {
			addRelatedEquipment(equipment.equipment_id, e).then(response => {
				setRelatedEquipment(response)
			})
		})
	}

	const disconnectEquipment = async(related_equipment) => {
		removeRelatedEquipment(equipment.equipment_id, related_equipment.equipment_id).then(response => {
			setRelatedEquipment(response)
		})

	}

	const addOrUpdatePoint = async (point) => {
		if (point.point_id) {
			updateEquipmentPoint(equipment.equipment_id, point).then(() => {
				getPointsForEquipment(equipment.equipment_id).then(response => {
					setPoints(response)
				})
			}).catch(err => {
				console.log(err)
			})
		} else {
			addEquipmentPoint(equipment.equipment_id, point).then(() => {
				getPointsForEquipment(equipment.equipment_id).then(response => {
					setPoints(response)
				})
			}).catch(err => {
				console.log(err)
			})
		}
	}

	const deletePoint = async (point) => {
		deleteEquipmentPoint(point).then(() => {
			getPointsForEquipment(equipment.equipment_id).then(response => {
				setPoints(response)
			})
		}).catch(err => {
			console.log(err)
		})
	}

	let fileViewClass = 'view-type' + (selectedHeader === 'file' ? ' selected' : '');
	let graphViewClass = 'view-type' + (selectedHeader === 'graph' ? ' selected' : '');

	let selectedType = equipment && brickTypes && brickTypes.find(t => t.brick_equipment_type === equipment.type)

	let selectedSystem= equipment && systemOptions && systemOptions.find(t => t.brick_system_type === equipment.system)
	let selectedProduct = equipment && equipment.product && products && products.find(p => p.product_id === equipment.product.product_id)
	if (equipment && equipment.product && equipment.product.company === "Unknown") {
		selectedProduct = null;
		setShowProductMode('unknown')
	}

  	return (
    <div className="layer3">
		{
			equipment ? <LoadedControls siteId={equipment.site.site_id} equipmentList={[equipment]} /> : null
		}
		
      	<div className="location">
        	{  equipment ?
				<div className="space-stats">
					<CommunicationInterfaceModal
						open={openInterfaceModal}
						siteId={equipment.site.site_id}
						addOrUpdateInterfaceCallback={addCommsInterface}
						getAllProtocols={getAllProtocols} 
						getAllPhysicalConnectionTypes={getAllPhysicalConnectionTypes}
						closeCallback={() => {
							setOpenInterfaceModal(false);
						}}
					/>
					<div className="section-header">Stats
						<div className="edit-element">
							<IconButton
										variant="contained"
										color="primary"
										aria-label={"Edit these values" }

										onClick={() => {
											setEditMode(!editMode)
									}}>
									<ModeEdit style={{fill: "#00b088", background: "white", transform: "scale(0.8)"}}/>
							</IconButton>
							<IconButton
										variant="contained"
										color="primary"
										aria-label={"View and edit equipment configuration" }

										onClick={() => {
											history.push("/variables/equipment/" + equipment.equipment_id)
									}}>
										<Settings style={{fill: "#003e51", background: "white", transform: "scale(0.8)"}}/>
							</IconButton>
						</div>
					</div>
					<div className="stats-container">
					{
						editMode ?
						<div className="stat-edit">
							<TextField label="Equipment Name" defaultValue={equipment.name} variant="outlined" size="small" onChange={(e) => {setName(e.target.value)}}/>
						</div>
						:
						null
					}

					{ editMode ?
						<div className="stat-edit">
						<Autocomplete
								disablePortal
								id="systemOptions"
								width={250}
								options={systemOptions || []}
								getOptionLabel={option => option.name}
								style={{ width: "250px" }}
								defaultValue={systemOptions.find(t => t.brick_system_type === equipment.system)}
								isOptionEqualToValue={(option, value) => option.brick_system_type === value.system}
								renderInput={(params) => <TextField {...params} label="System" variant="outlined" size="small" />}
								groupBy={(option) => option.parent}
								onChange={(event, newValue) => {
									let currentEquipment = Object.assign({}, equipment);
									currentEquipment.system = newValue.brick_system_type;
									setEquipment(currentEquipment);
								}}
							/>
						</div>
						:
						<div className="stat">
							<div className="stat-label">System</div>
							{selectedSystem ?
								<div className="stat-value">{selectedSystem.name}</div> :
								<div className="stat-unavailable">Add value</div> }
						</div>
					}

					{ editMode ?
						<div className="stat-edit">
						<Autocomplete
								disablePortal
								id="typeOptions"
								width={250}
								options={brickTypes || []}
								getOptionLabel={option => option.name}
								value={brickTypes.find(t => t.brick_equipment_type === equipment.type)}
								isOptionEqualToValue={(option, value) => option.brick_equipment_type === value.type}
								style={{ width: "250px" }}
								renderInput={(params) => <TextField {...params} label="Type" variant="outlined" size="small" />}
								groupBy={(option) => option.parent}
								onChange={(event, newValue) => {
									let currentEquipment = Object.assign({}, equipment);
									currentEquipment.type = newValue.brick_equipment_type;
									setEquipment(currentEquipment);
								}}
							/>
						</div>
						:
						<div className="stat">
							<div className="stat-label">Type</div>
							{selectedType ?
								<div className="stat-value">{selectedType.name}</div> :
								<div className="stat-unavailable">Add value</div> }
						</div>
					}

					{
						editMode ?
						<div className="stat-edit">
							<KeyboardDatePicker
								autoOk
								variant="inline"
								inputVariant="outlined"
								label="Installed Date"
								format="MM/dd/yyyy"
								size={"small"}
								value={parseISOString(equipment.installed_date)}
								InputAdornmentProps={{ position: "start" }}
								onChange={(date) => {setInstalledDate(date)}}
							/>
						</div>
						:
						<div className="stat">
							<div className="stat-label">Installed Date</div>
							{equipment.installed_date ?
								<div className="stat-value">{new Date(equipment.installed_date).toLocaleDateString()}</div> :
								<div className="stat-unavailable">Add value</div> }
						</div>
					}

					{ editMode ?
						<div className="stat-edit">
 							<RadioGroup value={showProductMode} name="product-group" row>
								{
									showProductMode === 'existing' ?
										<Autocomplete
											disablePortal
											id="product"
											options={products || []}
											getOptionLabel={option => option.label}
											fullWidth
											defaultValue={selectedProduct}
											isOptionEqualToValue={(option, value) => option.model === value.model}
											renderInput={(params) => <TextField {...params} label="Product" variant="outlined" size="small" required />}
											onChange={(event, newValue) => {
												let currentEquipment = Object.assign({}, equipment);
												currentEquipment.product = newValue
												setEquipment(currentEquipment)
											}}
										/> : null
								}
								{
									showProductMode === 'new' ?
										<div className="add-product-row">
											<TextField label="Company" variant="outlined" size="small" onChange={(e) => {setCompany(e.target.value)}}/>
											<TextField label="Model" variant="outlined" size="small" onChange={(e) => {setModel(e.target.value)}}/>
										</div>: null
								}
								<FormControlLabel value="existing" control={<Radio size="small"/>} label={<Typography sx={{ fontSize: 12 }}>Existing Product</Typography>}  onClick={() => { setShowProductMode('existing');  }}/>
								<FormControlLabel value="new" control={<Radio size="small"/>} label={<Typography sx={{ fontSize: 12 }}>New Product</Typography>}  onClick={() => { setShowProductMode('new'); }} />
								<FormControlLabel value="unknown" control={<Radio size="small"/>} label={<Typography sx={{ fontSize: 12 }}>Unknown</Typography>} onClick={() => { setShowProductMode('unknown'); }}/>								
							</RadioGroup>
						</div>
						:
						<div className="stat">
							<div className="stat-label">Product</div>
							{equipment.product ?
								<div className="stat-value">{equipment.product.company} {equipment.product.model} </div> :
								<div className="stat-unavailable">Add value</div> }
						</div>
					}

					{ editMode ?
						<div className="stat-edit">
							<RadioGroup value={interfaceMode} name="interface-type" row>
									<Autocomplete
									disablePortal
									id="comms-inetrface"
									fullWidth
									options={interfaces}
									defaultValue={equipment.communication_interface}
									getOptionLabel={option => option.name}
									isOptionEqualToValue={(option, value) => option.name === value.name}
									renderInput={(params) => <TextField {...params} label="Communication Interface" variant="outlined" fullWidth size="small" />}
									size="small"
									onChange={(event, newValue) => {
										let currentEquipment = Object.assign({}, equipment);
										currentEquipment.communication_interface = newValue
										setEquipment(currentEquipment)
									}}
								/>
								<FormControlLabel value="existing" control={<Radio size="small"/>} label={<Typography sx={{ fontSize: 12 }}>Existing Interface</Typography>}  onClick={() => { setInterfaceMode('existing');  }}/>
								<FormControlLabel value="new" control={<Radio size="small"/>} label={<Typography sx={{ fontSize: 12 }}>New Interface</Typography>}  onClick={handleNewInterface} />
							</RadioGroup>
						</div>
						:
						<div className="stat">
							<div className="stat-label">Communication Interface</div>
							{equipment.communication_interface ?
								<div className="stat-value">{equipment.communication_interface.name}</div> :
								<div className="stat-unavailable">Add value</div> }
						</div>
					}


					{ 
					(equipment.type.indexOf('Meter') > -1) ?
						editMode ?
							<div className="stat-edit">
							<Autocomplete
									disablePortal
									id="tariffOptions"
									width={250}
									options={tariffs}
									getOptionLabel={option => option.label}
									value={equipment.tariff && tariffs.find(t => t.openei_id === equipment.tariff.openei_id)}
									style={{ width: "250px" }}
									renderInput={(params) => <TextField {...params} label="Tariff" variant="outlined" size="small" />}
									groupBy={(option) => option.parent}
									onChange={(event, newValue) => {
										let currentEquipment = Object.assign({}, equipment);
										currentEquipment.tariff = newValue
										setEquipment(currentEquipment);
									}}
								/>
							</div>
							:
							<div className="stat">
								<div className="stat-label">Tariff</div>
								{equipment.tariff ?
									<div className="stat-value">{equipment.tariff.name}</div> :
									<div className="stat-unavailable">Add value</div> }
							</div>
						:
						null
					}

					{
						<div className={editMode ? "stat-edit" : "stat"}>
							<TextField 
								label="Selector"
								defaultValue={equipment.selector} 
								disabled={!editMode}
								variant="standard" 
								size="small" 
								onChange={(e) => {setSelector(e.target.value)}}
							>
							</TextField>
						</div>
					}

					{
						<div className={editMode ? "stat-edit" : "stat"}>
							<TextField 
								label="Controlled by"
								defaultValue={equipment.controlled_by} 
								disabled={!editMode}
								variant="standard" 
								size="small" 
								onChange={(e) => {setControlledBy(e.target.value)}}
							>
							</TextField>
						</div>
					}



					{editMode ?
							<div className="stat-edit">
								<EntityAutocomplete
									value={{
										context: equipment?.location?.location_type,
										id: equipment?.location?.id,
										name: equipment?.location?.name
									}}
									style={{width:300}}
									input={{label:"Equipment Location" }}
									accept={["building", "space", "zone", "site"]}
									onEntitySelected={({ context, id, name }) => {
										let currentEquipment = Object.assign({}, equipment);
										currentEquipment.element_id = `${context}_${id}`
										currentEquipment.location = {
											location_type: context,
											id, 
											name
										}
										setEquipment(currentEquipment);
									}}
									// TODO: add this context filter back in when we can search for zones (or sites) given 
									//       the context. currently, only buildings and spaces are returned under a site context.
									//       leaving this as-is will eventually become problematic as one could mistakenly
									//       transfer equipment to a location belonging to another customer. best to keep
									//       it all under one site.
									// context={{
									// 	type: "site",
									// 	id: equipment?.site?.site_id
									// }}
								/>
							</div>
					: null}

					{
						<div className={editMode ? "stat-edit" : "stat"}>
							<div className="stat-label">Active</div>
							<Checkbox
                            variant="contained"
                            color="primary"
                            aria-label={"Is Active"}
                            size={"small"}
                            defaultChecked={equipment.is_active}
							onChange={(e) => {toggleActive()}}
                            disabled={!editMode}
							>
							</Checkbox>
						</div>
					}
					{
						editMode ? (
							<>
								<div style={{ flexBasis: '100%' }} className="stat">
									<Button variant="contained" onClick={cancelEdit} color='error'>Cancel</Button> &nbsp;
									<LoadingButton variant="contained" loading={isSubmitting} onClick={submitChanges} color='primary'>Submit</LoadingButton>
								</div>
							</>
						) : null
					}
					</div>
				</div>
			: null }
          <div className="view-chooser">
            <div className="view-types">
			{ photos && photos.length > 0 ?
				<div className={fileViewClass} onClick={() => { setSelectedHeader('file');}}>
					Images
              	</div> : null
			}
            { equipment && points && points.length > 0 ?
				<div className={graphViewClass} onClick={() => {setSelectedHeader('graph');}}>
					Graph
				</div> : null
			}
            </div>
          </div>
          {selectedHeader === 'file' ? (
            			<div className="photo-container">
						<PhotoCarousel files={photos} />
					</div>
          ) : equipment && points && points.length > 0? (
            <LineGraph equipment={equipment} points={points} />
          ) : null}

		  <PointList 
		  	equipment={equipment} 
			points={points} 
			getAllBrickTypes={getBrickPointTypes} 
			getAllUnits={getAllUnits} 
			addOrUpdatePointCallback={addOrUpdatePoint} 
			deletePointCallback={deletePoint} />
			<MergeEquipmentForm destinationEquipment={equipment} />
		  <RelatedEquipmentList 
		  	equipment={relatedEquipment} 
			id={equipment && equipment.equipment_id} 
			allEquipment={allEquipment} 
			connectEquipmentCallback={connectEquipment} 
			disconnectEquipmentCallback={disconnectEquipment} 
		  />
		  <Notes notes={notes} onSubmit={addNote} />
		  <FileList files={files} context="equipment" id={equipment && equipment.equipment_id} filesAccessor={getFiles} />
		  <ContactsList
                    fetchContacts={fetchContacts}
                    associateContact={(email) => { return associateEquipmentContact(equipment && equipment.equipment_id, email)}}
			/>
        </div>
	</div>
  );
};

export default ShowEquipment;
